import { render, staticRenderFns } from "./GlobalIndicatorsChart.vue?vue&type=template&id=cb508020&scoped=true&"
import script from "./GlobalIndicatorsChart.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsChart.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalIndicatorsChart.vue?vue&type=style&index=0&id=cb508020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb508020",
  null
  
)

export default component.exports